import styled from "styled-components"

export const AdWrapper = styled.div`
  background-color: #f5f5f5;
  width: 100%
  margin-bottom: 30px;
  padding: 10px;
  text-align: center;
`